import { Endpiont } from 'shared/utils/Endpoints';
import { HTTP_CLIENT } from '../../utils/Interceptor';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toastMessage } from 'shared/components/toast/Toast';
// ------------------ list PO-------
const getAllTask = async (filter) => {
    const {
        data: { data }
    } = await HTTP_CLIENT.get(Endpiont.task.list + `${filter ? '?' + filter : ''}`);
    return data;
};
const GetAllTaskQuery = (filter) => {
    return useQuery(['TaskList', filter], () => getAllTask(filter));
};
// ------------------ Update Task-------
const updateTask = async (payload) => {
    const { id, body } = payload;
    return await HTTP_CLIENT.patch(Endpiont.task.update + id, body);
};
const UpdateTaskMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(updateTask, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('TaskList');
            toastMessage('success', 'Task Updated Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};
// --------------------Submit Task-----------------------
const submitTask = async (payload) => {
    const { id, body } = payload;
    return await HTTP_CLIENT.patch(Endpiont.task.submit + id, body);
};
const SubmitTaskMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(submitTask, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('TaskList');
            toastMessage('success', 'Task Submited Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};
// -------------------- Assign OR Unassign Task ------------
const assignORUnAssignTask = async (payload) => {
    return await HTTP_CLIENT.post(Endpiont.task.assignOrUnassignTask, payload);
};
const AssignORTaskMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(assignORUnAssignTask, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('TaskList');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};

export { GetAllTaskQuery, UpdateTaskMutation, AssignORTaskMutation, SubmitTaskMutation };
